export const isYouTubeUrl = (url: string) =>
  /youtu\.be|youtube\.com/.test(url);

export const isMp4Url = (url: string) =>
  url.toLowerCase().endsWith('.mp4');

export const getYoutubeVideoId = (url: string): string | null => {
  const patterns = [
    /youtube\.com\/watch\?v=([^&]+)/,
    /youtu\.be\/([^?&]+)/,
    /youtube\.com\/embed\/([^?&]+)/,
    /youtube\.com\/shorts\/([^?&]+)/,
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match?.[1]) return match[1];
  }
  return null;
};
